import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        props.cordialInit();
    }

    componentDidMount() {
        if (this.props.mode) {
            if (this.props.mode == 'page') {
                this.props.sendBrowsePageEvent();
            }
        }
    }

    shouldComponentUpdate() {
        return false;
    }

    render({ mode }) {
        return (<cordial mode={mode} />);
    }
}

const mapDispatchToProps = (dispatch) => ({
    cordialInit: () => dispatch({ type: 'cordial:init' }),
    sendBrowsePageEvent: (event) => dispatch({ type: 'cordial:page', payload: event }),
});

export default connect(null, mapDispatchToProps)(Component);